import React from 'react';

export default class PlanosDescricao extends React.Component{

  renderPlanos() {
    let lista = this.props.planos.map((value, i) =>{
      return(
        <div className='plano-desc'>
        <div className='button-plano__title'>{value.nome}</div>
        <div className='button-plano__name'>{value.periodicidade}</div>
        <div className='button-plano__price'>{value.valor}</div>
        <div className='button-plano__desc'>{value.descricao_completa}</div>
        </div>
      );
    });
    return lista;
  }

  render(){
    const planos = this.renderPlanos();
    return(
      <div className='box-plano-desc'>
      {/*planos*/}

      <div>

        Os pagamentos podem ser feitos por cartão de crédito ou boleto bancário.<br /><br />

<strong class="strong-txt">Plano Mensal (Assinatura):</strong> este plano é uma assinatura mensal, ou seja, quando você insere seu cartão no cadastro, está autorizando a cobrança automática todo mês de R$ 34,90. Você pode cancelar este plano a qualquer momento, basta enviar um email para contato@foco90.com.br pedindo o cancelamento. Na assinatura feita por boleto bancário, todo mês será enviado para o email do cliente o boleto a ser pago, que exige até 3 dias úteis para confirmação do pagamento (prazo dos bancos). <br /><br />

<strong class="strong-txt">Plano Anual:</strong> Esse plano é um pacote para utilização de 1 ano do programa, com um preço único de R$ 286,80, que pode ser dividido em 12 parcelas de R$ 23,90 no cartão de crédito. Pode também ser pago no boleto, à vista, o preço inteiro do pacote. Neste plano, é possível o cancelamento em até 7 dias após a compra, com reembolso total.
<br /><br />
Obs: Após o período gratuito, você será redirecionado para escolher o plano, se desejar continuar no Foco90.

      </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/PlanosDescricao.js